import React, { Component } from "react";
import { withRouter } from 'react-router-dom';
import "./../../../View.css";
import "./../../../Grid.css";
import "./../../../Form.css";
import "./../../../App.css";
import DownloadClaimSearchForm from './DownloadClaimSearchForm';
import SearchView from "../../../widgets/SearchView";
import withMenuPermission from "../../../widgets/withMenuPermission";
import { ViewContainer } from "./../../../View.jsx";
import ViewUtils from "../../../ViewUtils";

const utils = new ViewUtils();
const toolbarRef = React.createRef();

const headCells = [
    { id: 'ClaimNumber', numeric: false, disablePadding: false, label: 'Claim Number' },
    { id: 'ClaimDate', numeric: false, disablePadding: false, label: 'Claim Date' },
    { id: 'OrganisationSDLNumber', numeric: false, disablePadding: false, label: 'Organisation SDL Number' },
    { id: 'RequestedBy', numeric: false, disablePadding: false, label: 'Requested By' },
    { id: 'RequestedDate', numeric: false, disablePadding: false, label: 'Requested Date' }
];


class DownloadClaimSearch extends Component {

    constructor(props) {
        super(props);

        this.state = {
            selectedClaim: null,
            model: {
                ClaimNumber: null,
                ApprovedID: null,
                DiscretionaryGrantTypeID: null,
                EmployerID: null
            },
            keyUpSwitch: false

        }

        this.toolbarConfig = {
            items: [
                {
                    type: "buttonGroup",
                    buttons: [
                        { id: 'close', label: 'CLOSE', tooltip: 'Close', icon: 'CloseIcon' }
                    ]
                },
                {
                    type: "devider"
                },
                {
                    type: "buttonGroup",
                    buttons: [
                        {id: 'downloadClaim', label: 'Download Claim', icon: 'DownloadIcon', tooltip: 'Download claim for selected record',disabled: utils.isNull(this.state.selectedClaim)}
                    ]
                }
            ]
        };

    }

    onkeyup(e) {
        if (e.charCode == 13) {
            this.setState({ keyUpSwitch: !this.state.keyUpSwitch })
        }
    }

    handleSelection = (selection) => {
        if (selection !== null && selection.length !== 0) {
            this.setState({ selectedClaim: selection, Message: "" },
                () => {
                    toolbarRef.current.setButtonDisabled("downloadClaim", selection.length === 0);
                }
            )
        } else {
            this.setState({ selectedClaim: null, Message: "" },
                () => {
                    toolbarRef.current.setButtonDisabled("downloadClaim", selection.length === 0);
                }
            )
        }
    }

    base64ToArrayBuffer(base64) {
        var binary_string = window.atob(base64);
        var len = binary_string.length;
        var bytes = new Uint8Array(len);
        for (var i = 0; i < len; i++) {
            bytes[i] = binary_string.charCodeAt(i);
        }
        return bytes.buffer;
    };

    downloadClaim = () => {
        
        let data = {
            Id: this.state.selectedClaim[0].Id,
            DiscretionaryGrantTypeID: this.state.model.DiscretionaryGrantTypeID.Id
        }
        let url = "api/sims/DownloadClaim/GrantClaimDownload";
        utils.invokeUrl(url, (response) => {
            var blob = new Blob([this.base64ToArrayBuffer(response.Base64)], { type: response.Type });
            var url = URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.download = response.Name;
            link.target = '_blank';
            link.click();
            toolbarRef.current.setButtonDisabled("downloadClaim", true);
        },
            null,
            {
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': "Bearer " + localStorage.getItem("token")
                },
                body: JSON.stringify(data)
            }
        )
    };

    handleFormValueChange = (values) => {
        if (JSON.stringify(this.state.model) !== JSON.stringify(values)) {
            this.setState({ model: values });
        }
    }

    handleToolbarButtonClick = (buttonId) => {
        if (buttonId === "close") {
            this.props.history.push({
                pathname: '/ProcessingNav'
            })
        } else if ("downloadClaim" === buttonId) {
            this.downloadClaim();
            toolbarRef.current.setButtonDisabled("downloadClaim", true);
        }
    }

    render() {

        return (
            <ViewContainer title={''}>
                <p className="breadcrumbs">
                    {"Grant Processing > Download Claims"}
                </p>
                <SearchView headCells={headCells} dataUrl="api/sims/DownloadClaim/GetGrantClaimForDownloadSearch" 
                    model={this.state.model} toolbarConfig={this.toolbarConfig} searchParameters={this.searchParameters}
                    onLookupValueChange={this.props.onLookupValueChange} 
                    handleObject={true}
                    toolbarRef={toolbarRef}
                    history={this.props.history}
                    searchLabel={"SEARCH"}
                    autoFetchData={false}
                    keyUpSwitch={this.state.keyUpSwitch}
                    hasButtonClickHandler={true} buttonClickHandler={this.handleToolbarButtonClick}
                    setSelection={(selection) => { this.handleSelection(selection) }}
                >
                    <DownloadClaimSearchForm data={this.state.model}
                        valueChangeHandler={(values) => this.handleFormValueChange(values)}  />
                </SearchView>
            </ViewContainer>
        );
    }
}


export default withRouter(withMenuPermission(DownloadClaimSearch));



